const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=+523335781778&text=Hola, me interesa que administren mi propiedad.";

const PropertyManagementCTA = () => (
  <section className="py-16 md:py-24 bg-brand-primary text-white">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        ¿Listo para generar ingresos adicionales?
      </h2>
      <p className="text-lg md:text-xl text-white/90 mb-8">
        Contáctanos hoy y comienza a recibir más ingresos mes a mes.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="#top"
          className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-white text-brand-primary font-semibold hover:bg-white/90 transition-colors"
          aria-label="Me interesa"
        >
          Me interesa
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors"
          aria-label="Abrir WhatsApp"
        >
          WhatsApp
        </a>
      </div>
    </div>
  </section>
);

export default PropertyManagementCTA;
